import { ClarisApiError } from '../../domain/error';

// Action Types

const DATA_SETTINGS_DATA_RESEND = 'DATA_SETTINGS_DATA_RESEND' as const;
const DATA_SETTINGS_DATA_RESEND_REQUEST =
  'DATA_SETTINGS_DATA_RESEND_REQUEST' as const;
const DATA_SETTINGS_DATA_RESEND_SUCCESS =
  'DATA_SETTINGS_DATA_RESEND_SUCCESS' as const;
const DATA_SETTINGS_DATA_RESEND_FAILURE =
  'DATA_SETTINGS_DATA_RESEND_FAILURE' as const;

export const DataSettingsDataResendActionTypes = {
  DATA_SETTINGS_DATA_RESEND,
  DATA_SETTINGS_DATA_RESEND_REQUEST,
  DATA_SETTINGS_DATA_RESEND_SUCCESS,
  DATA_SETTINGS_DATA_RESEND_FAILURE,
};

// Action Creators

function dataSettingsDataResendAction(hallCode: string, dates: string[]) {
  return {
    type: DATA_SETTINGS_DATA_RESEND,
    payload: { hallCode, dates },
  };
}

function dataSettingsDataResendRequestAction() {
  return {
    type: DATA_SETTINGS_DATA_RESEND_REQUEST,
  };
}

function dataSettingsDataResendSuccessAction() {
  return {
    type: DATA_SETTINGS_DATA_RESEND_SUCCESS,
  };
}

function dataSettingsDataResendFailureAction(error: ClarisApiError) {
  return {
    type: DATA_SETTINGS_DATA_RESEND_FAILURE,
    payload: { error },
  };
}

export const DataSettingsDataResendActionCreators = {
  dataSettingsDataResendAction,
  dataSettingsDataResendRequestAction,
  dataSettingsDataResendSuccessAction,
  dataSettingsDataResendFailureAction,
};

// Actions

export type DataSettingsDataResendAction = ReturnType<
  typeof dataSettingsDataResendAction
>;

type DataSettingsDataResendActions =
  | DataSettingsDataResendAction
  | ReturnType<typeof dataSettingsDataResendRequestAction>
  | ReturnType<typeof dataSettingsDataResendSuccessAction>
  | ReturnType<typeof dataSettingsDataResendFailureAction>;

// State
type DataSettingsDataResendState = {
  isLoading: boolean;
  error: ClarisApiError | undefined;
};

const initialState: DataSettingsDataResendState = {
  isLoading: false,
  error: undefined,
};

// Selector
export function dataSettingsDataResendLoadingSelector(rootState: {
  dataSettingsDataResend: DataSettingsDataResendState;
}) {
  return rootState.dataSettingsDataResend.isLoading;
}

export function dataSettingsDataResendErrorSelector(rootState: {
  dataSettingsDataResend: DataSettingsDataResendState;
}) {
  return rootState.dataSettingsDataResend.error;
}

// Reducer

export function dataSettingsDataResendReducer(
  state = initialState,
  action: DataSettingsDataResendActions
): DataSettingsDataResendState {
  switch (action.type) {
    case DATA_SETTINGS_DATA_RESEND_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case DATA_SETTINGS_DATA_RESEND_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case DATA_SETTINGS_DATA_RESEND_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
